<!-- eslint-disable max-len -->
<template>
  <div
    :id="id"
    class="properties-field"
    style="background-color: rgba(255,255,255,0.9);"
  >
    <div class="wrap-properties">
      <!-- Configuration Title -->
      <div class="properties-field-title">
        <h4 class="title">Configuration</h4>
        <div
          class="close-properties"
          @click="!showModalFieldLibrary ? closeConfiguration() : null"
        >
          &times;
        </div>
      </div>

      <!-- Configuration Content -->
      <div class="properties-field-content properties-field-content-config">
        <div class="section-field input-field">
          <!-- Title Section -->
          <b-form
            :class="{'error-input' : $v.dataSetup.title.$error}"
            class="input-field m__b--14">
            <label> Title </label>
            <j-input
              v-model="dataSetup.title"
              :error-required="false"
              placeholder="Enter title view"
            />
          </b-form>

          <!-- Filter Configuration -->
          <div class="configuration-section">
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">Filter</h4>
                <p class="configuration-section-desc">
                  Filter data according to the parameters
                </p>
              </div>

              <!-- Filter Operator -->
              <div class="filter-option">
                <div class="filter-selected">{{ dataSetup.filterOperator }}</div>
                <i
                  class="fa fa-chevron-down"
                  @click="showFilterOptions = true"
                />

                <!-- Select Filter Operator -->
                <div
                  v-if="showFilterOptions"
                  class="filter-options"
                >
                  <p>Operator</p>

                  <div class="d-flex align-items-center justify-content-around">
                    <div
                      v-for="operator in filterOperatorOptions"
                      :key="operator.id"
                      :class="{'operator-selected': operator.id === dataSetup.filterOperator }"
                      class="operator-option"
                      @click="closeFilterOptions(operator.id)"
                    >
                      {{ operator.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Filter by Value -->
            <h3 class="configuration-section-subtitle">By Value</h3>
            <div
              v-for="(data, index) in dataSetup.filter"
              :key="index"
              class="div-filter"
            >
              <div class="header-filter">
                <div class="index">{{ index + 1 }}</div>
                <i
                  class="fa fa-trash"
                  @click="deleteFilter(index)"
                />
              </div>
              <b-form class="mb-2">
                <label> Column </label>
                <j-single-select
                  v-model="data.key"
                  :error-required="false"
                  :options="variableOptions"
                  :placeholder="'Select Column'"
                  value-format="object"
                  label="label"/>
              </b-form>
              <b-form>
                <label> Value </label>
                <j-input
                  v-model="data.value"
                  :error-required="false"
                  :placeholder="'Input Filter Value'"/>
              </b-form>
            </div>

            <div
              class="btn-add-config"
              @click="addFilter">
              + Add Parameter
            </div>

            <div class="separator" />

            <!-- Filter by Function -->
            <h3 class="configuration-section-subtitle">By Function</h3>
            <div
              v-for="(data, index) in dataSetup.filter_function"
              :key="index"
              class="div-filter"
            >
              <div class="header-filter">
                <div class="index">{{ index + 1 }}</div>
                <i
                  class="fa fa-trash"
                  @click="deleteFilterFunction(index)"
                />
              </div>
              <b-form class="mb-2">
                <label> Column </label>
                <j-single-select
                  v-model="data.key"
                  :error-required="false"
                  :options="variableOptions"
                  :placeholder="'Select Column'"
                  value-format="object"
                  label="label"/>
              </b-form>
              <b-form>
                <label> Function </label>
                <j-single-select
                  v-model="data.value"
                  :options="listFunction"
                  :placeholder="'Select Function'"
                  :error-required="false"
                  label="name" />
              </b-form>
            </div>

            <div
              class="btn-add-config"
              @click="addFilterFunction">
              + Add Parameter
            </div>
          </div>

          <!-- Sorting Configuration -->
          <div class="configuration-section">
            <h4 class="configuration-section-title">Sorting</h4>
            <p class="configuration-section-desc">
              The displayed data can be sorted according to the specified parameters
            </p>
            <b-form
              :class="{'error-input' : $v.dataSetup.sorting.key.$error}"
              class="mb-2"
            >
              <label> Column </label>
              <j-single-select
                v-model="dataSetup.sorting.key"
                :options="variableOptions"
                :placeholder="'Select Column'"
                :error-required="false"
                value-format="object"
                label="label" />
            </b-form>
            <b-form :class="{'error-input' : $v.dataSetup.sorting.order.$error}">
              <label> Order Type </label>
              <j-single-select
                v-model="dataSetup.sorting.order"
                :options="orderOptions"
                :error-required="false"
                :placeholder="'Select Order Type'"
                value-format="object"
                label="label" />
            </b-form>
          </div>
        </div>

        <!-- Search Options Section -->
        <div class="section-field input-field">
          <h4 class="title-section">Search Options</h4>

          <!-- Fields Search Options Configuration -->
          <div class="configuration-section">
            <h4 class="configuration-section-title">Fields</h4>
            <p class="configuration-section-desc">
              The field used can be adjusted as needed
            </p>

            <draggable
              v-model="dataSetup.search_options_list"
              :options="{
                animation:300,
                handle:'.icon-drag'
              }"
              class="d-flex flex-wrap"
            >
              <div
                v-for="(data, index) in dataSetup.search_options_list"
                :key="index"
                :class="{'selected': index === selectedIndexField}"
                class="field-list"
              >
                <p class="column-name">{{ data.name }}</p>

                <field-preview
                  :column="data"
                />

                <!-- Edit or Delete -->
                <div class="edit-or-delete">
                  <div class="button">
                    <!-- Edit -->
                    <div
                      class="edit"
                      @click="editField(index)"
                    >
                      <i class="fa fa-pencil-square-o" />
                    </div>
                    <!-- Delete -->
                    <div
                      class="delete"
                      @click="deleteField(index)"
                    >
                      <i class="fa fa-trash" />
                    </div>
                  </div>
                </div>
              </div>
            </draggable>

            <div
              class="btn-add-config"
              @click="openModalFieldLibrary"
            >
              + Add Field
            </div>
          </div>
        </div>

        <!-- Hide Checkbox Configuration -->
        <div
          v-if="type === 'requestor' || type === 'approver'"
          class="configuration-section"
        >
          <div class="configuration-toggle-in-title">
            <div class="wrap-title">
              <h4 class="configuration-section-title">Hide Checkbox</h4>
              <p class="configuration-section-desc">Allows to disable bulk action {{ type === 'approver' ? 'approval' : type }}</p>
            </div>
            <j-switch v-model="dataSetup.isHideCheckbox" />
          </div>
        </div>
      </div>

      <!-- Configuration Button -->
      <div
        :class="{ 'justify-content-end': !isHaveConfiguration }"
        class="properties-field-button"
      >
        <button
          v-if="isHaveConfiguration"
          :disabled="showModalFieldLibrary"
          class="button-border"
          @click="deleteView"
        >
          <i class="fa fa-trash" /> Delete View
        </button>

        <div class="d-flex align-items-center">
          <button
            :disabled="showModalFieldLibrary"
            class="button-border mr-2"
            @click="closeConfiguration"
          >
            Close
          </button>

          <button
            :disabled="showModalFieldLibrary"
            class="button-blue"
            @click="submitForm"
          >
            Apply
          </button>
        </div>
      </div>
    </div>

    <!-- Properties -->
    <properties-field
      v-if="selectedField"
      :ref="idProperties"
      :id="[idProperties]"
      :field-detail="selectedField"
      :variable-options="variables"
      :field-ui-key="dataSetup.search_options_list"
      :is-detail-view="true"
      :is-group="true"
      :is-new-field="isNewFieldGroup"
      @delete-field="deleteField"
      @close-properties="togglePropertiesField(false)"
      @submit-mode="submitField"
    />
  </div>
</template>

<script>
/* eslint-disable max-len */
import { required } from 'vuelidate/lib/validators';
import draggable from 'vuedraggable';
// Components
import PropertiesField from '@/views/experience-manager-v2/partials/PropertiesField';
import FieldPreview from '@/views/experience-manager-v2/partials/FieldPreview';
import jSwitch from '@/components/inputs/jSwitch';
// Mixins
import jMixAutoScroll from '@/mixins/jMixAutoScroll';
import jMixConfiguration from '@/mixins/form-ui-v2/jMixConfiguration';

export default {
  name: 'ListViewConfiguration',

  components: {
    draggable,
    PropertiesField,
    FieldPreview,
    jSwitch,
  },

  mixins: [jMixAutoScroll, jMixConfiguration],

  props: {
    id: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'default',
    },
    dataConfig: {
      type: Object,
      default: () => {},
    },
    listFunction: {
      type: Array,
      default: () => [],
    },
    variables: {
      type: Array,
      default: () => [],
    },
    variableOptions: {
      type: Array,
      default: () => [],
    },
    isHaveConfiguration: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dataSetup: {
        title: null,
        sorting: {
          key: null,
          order: null,
        },
        filter: [
          {
            key: null,
            value: null,
          },
        ],
        filter_function: [
          {
            key: null,
            value: null,
          },
        ],
        filterOperator: null,
        search_options_list: [],
        isHideCheckbox: false,
      },
    };
  },

  created() {
    if (this.dataConfig) {
      this.dataSetup.title = this.dataConfig.title || null;
      this.dataSetup.sorting = this.dataConfig.sorting;
      this.dataSetup.filter = this.dataConfig.filter;
      this.dataSetup.filter_function = this.dataConfig.filter_function;
      this.dataSetup.filterOperator = this.dataConfig.filterOperator || 'and';
      this.dataSetup.search_options_list = this.dataConfig.search_options_list || [];

      if (this.type === 'default') {
        delete this.dataSetup.isHideCheckbox;
      } else {
        this.dataSetup.isHideCheckbox = this.dataConfig.isHideCheckbox;
        delete this.dataSetup.column_bulking_update;
      }
    }
  },

  methods: {
    // Open/close stacked properties
    togglePropertiesField(status) {
      if (status) {
        setTimeout(() => {
          const element = document.getElementById(this.idProperties);
          const elementParent = document.getElementById(this.id);
          if (element) {
            elementParent.classList.add('show-properties-group');
            element.classList.add('show-properties-field');
          }
        }, 200);
      } else {
        const element = document.getElementById(this.idProperties);
        const elementParent = document.getElementById(this.id);
        if (element) {
          element.classList.remove('show-properties-field');
          elementParent.classList.remove('show-properties-group');
        }

        setTimeout(() => {
          this.selectedField = null;
          this.selectedIndexField = null;
          this.isNewFieldGroup = false;
          this.setIsSearch(false);
        }, 200);
      }
    },

    submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        this.$emit('submit', this.dataSetup, this.type);
        this.closeConfiguration();
      } else {
        this.scrollToErrorField('error-input');
      }
    },

    deleteView() {
      this.$emit('delete-view', this.type);
    },

    closeConfiguration() {
      this.$emit('close-configuration');

      setTimeout(() => {
        this.dataSetup = {
          title: null,
          sorting: {
            key: null,
            order: null,
          },
          filter: [
            {
              key: null,
              value: null,
            },
          ],
          filter_function: [
            {
              key: null,
              value: null,
            },
          ],
          filterOperator: null,
          search_options_list: [],
          isHideCheckbox: false,
        };

        this.$v.dataSetup.$reset();
      }, 400);
    },
  },

  validations() {
    return {
      dataSetup: {
        title: { required },
        sorting: {
          key: { required },
          order: { required },
        },
        filter: { },
        filter_function: { },
        filterOperator: { },
        search_options_list: { },
        isHideCheckbox: { },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/partials/configuration/ListViewConfiguration.vue